import React from 'react';
import { Select, Tag, message } from 'antd';
import { PushpinOutlined } from '@ant-design/icons';
import axiosRequest from '@/api';

const { Option } = Select;

interface SimplePinManagerProps {
    campaignId: number;
    currentPriority: number;
    onPriorityChange?: (priority: number) => void;
    disabled?: boolean;
}

const SimplePinManager: React.FC<SimplePinManagerProps> = ({
    campaignId,
    currentPriority,
    onPriorityChange,
    disabled = false
}) => {
    const handleChange = async (newPriority: number) => {
        try {
            // API 호출
            await axiosRequest.requestAxios('patch', `/${campaignId}/pin-priority`, {
                pin_priority: newPriority
            });

            onPriorityChange?.(newPriority);
            message.success('고정 순서가 변경되었습니다');
        } catch (error) {
            console.error('Pin priority update failed:', error);
            message.error('변경에 실패했습니다');
        }
    };

    const getPriorityLabel = (priority: number) => {
        if (priority >= 100) return '최상단 고정';
        if (priority >= 90) return '차상단 고정';
        if (priority > 1) return '일반 고정';
        return '고정 안함';
    };

    const getPriorityColor = (priority: number) => {
        if (priority >= 100) return 'red';
        if (priority >= 90) return 'orange';
        if (priority > 1) return 'blue';
        return 'default';
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {/* 현재 상태 표시 */}
            <Tag
                color={getPriorityColor(currentPriority)}
                icon={currentPriority > 1 ? <PushpinOutlined /> : null}
                style={{ textAlign: 'center' }}
            >
                {getPriorityLabel(currentPriority)}
            </Tag>

            {/* 변경 드롭다운 */}
            <Select
                value={currentPriority}
                onChange={handleChange}
                disabled={disabled}
                size="small"
                style={{ width: '100%' }}
            >
                <Option value={1}>고정 안함</Option>
                <Option value={10}>일반 고정</Option>
                <Option value={90}>차상단 고정</Option>
                <Option value={100}>최상단 고정</Option>
            </Select>
        </div>
    );
};

export default SimplePinManager;